// https://stackoverflow.com/questions/31089801/extending-error-in-javascript-with-es6-syntax-babel
import { Message } from 'element-ui'

class BaseException extends Error {
  constructor (message) {
    super(message)
    this.name = this.constructor.name
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor)
    } else {
      this.stack = (new Error(message)).stack
    }
  }
}

class ApiRequestFailedException extends BaseException {
}

class ApiResponseNotSuccessfulException extends BaseException {
  constructor (code, message) {
    super(message)
    this.code = code
  }
}

class UnauthenticatedException extends BaseException {
}

class IllegalArgumentException extends BaseException {
  constructor (argumentName, message) {
    super(message)
    this.argumentName = argumentName
  }
}

function operateError (error, desc) {
  if (error instanceof UnauthenticatedException) {
    return
  }
  Message({
    message: `${desc || '操作'}出错：${error.message}`,
    type: 'error'
  })
}

export {
  ApiRequestFailedException,
  ApiResponseNotSuccessfulException,
  UnauthenticatedException,
  IllegalArgumentException,
  operateError
}
